import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck, Zap, Lock, Download, Smartphone, MessageCircle, RotateCcw } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function BonusesFinalCTASection() {
  return <section id="comprar" className="w-full bg-[#1A1A1A] text-white py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden scroll-mt-4" data-id="element-33">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 w-[700px] h-[700px] bg-[#0B6B3A] opacity-20 rounded-full blur-[140px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none" data-id="element-34" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-36">
          <h2 className="text-4xl sm:text-5xl font-bold mb-4 leading-tight" data-id="element-37">
            Sí, quiero el Mapa 5R + los 3 Bonos por{' '}
            <span className="text-[#DCF8C6]" data-id="element-38">$6.39</span>
          </h2>

          <p className="text-lg text-gray-400 mb-12 max-w-xl mx-auto" data-id="element-39">
            Acceso inmediato. Descarga directa. Sin suscripción.
          </p>

          {/* Pricing Card */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.92
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.15
        }} className="bg-gradient-to-b from-white/10 to-white/5 border-2 border-[#0B6B3A]/60 rounded-3xl p-8 sm:p-10 mb-10 max-w-lg mx-auto relative" data-id="element-40">
            {/* Badge */}
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 whitespace-nowrap" data-id="element-41">
              <span className="inline-flex items-center gap-1.5 bg-[#0B6B3A] text-white text-sm font-bold px-5 py-2 rounded-full shadow-lg shadow-[#0B6B3A]/30" data-id="element-42">
                <Zap className="w-4 h-4" data-id="element-43" />
                68% DE DESCUENTO — PRECIO DE LANZAMIENTO
              </span>
            </div>

            {/* Price */}
            <div className="mt-6 mb-6" data-id="element-44">
              {/* Bonuses savings callout */}
              <div className="bg-[#0B6B3A]/20 border border-[#0B6B3A]/40 rounded-xl px-4 py-3 mb-5 text-sm text-[#DCF8C6]" data-id="element-45">
                <p className="font-bold mb-1.5" data-id="element-46">
                  Incluye 3 bonos valorados en $47:
                </p>
                <ul className="space-y-1 text-left text-[#DCF8C6]/80 text-xs" data-id="element-47">
                  <li className="flex justify-between" data-id="element-48">
                    <span data-id="element-49">Bono #1: Diagnóstico Flash</span>
                    <span className="font-semibold text-[#DCF8C6]" data-id="element-50">$17</span>
                  </li>
                  <li className="flex justify-between" data-id="element-51">
                    <span data-id="element-52">Bono #2: Cierres Suaves</span>
                    <span className="font-semibold text-[#DCF8C6]" data-id="element-53">$17</span>
                  </li>
                  <li className="flex justify-between" data-id="element-54">
                    <span data-id="element-55">Bono #3: Follow-up Inteligente</span>
                    <span className="font-semibold text-[#DCF8C6]" data-id="element-56">$13</span>
                  </li>
                  <li className="flex justify-between border-t border-[#DCF8C6]/20 pt-1 mt-1 font-bold text-[#DCF8C6]" data-id="element-57">
                    <span data-id="element-58">Total bonos</span>
                    <span data-id="element-59">$47 GRATIS</span>
                  </li>
                </ul>
              </div>

              <div className="flex items-center justify-center gap-3 mb-1" data-id="element-60">
                <div className="text-center" data-id="element-61">
                  <p className="text-gray-500 text-xs mb-0.5" data-id="element-62">
                    Valor total del paquete
                  </p>
                  <span className="text-gray-500 line-through text-2xl font-medium" data-id="element-63">
                    $74
                  </span>
                </div>
                <ArrowRight className="w-4 h-4 text-gray-500" data-id="element-64" />
                <div className="text-center" data-id="element-65">
                  <p className="text-[#DCF8C6]/70 text-xs mb-0.5" data-id="element-66">
                    Tu precio hoy
                  </p>
                  <span className="text-[#DCF8C6] text-6xl sm:text-7xl font-black tracking-tight" data-id="element-67">
                    $6.39
                  </span>
                </div>
              </div>
              <p className="text-gray-500 text-sm" data-id="element-68">
                Ahorrás <span className="text-[#DCF8C6] font-bold" data-id="element-69">$67.61</span>{' '}
                — Precio por tiempo limitado
              </p>
            </div>

            <div className="border-t border-white/10 my-6" data-id="element-70" />

            {/* What's included */}
            <ul className="text-left space-y-2.5 mb-8 max-w-sm mx-auto" data-id="element-71">
              {['Mapa 5R: 25 scripts de cierre', 'Bono #1: Diagnóstico Flash (valor $17)', 'Bono #2: Cierres Suaves (valor $17)', 'Bono #3: Follow-up Inteligente (valor $13)'].map((item, i) => <li key={i} className="flex items-center gap-2.5 text-gray-300 text-sm" data-id="element-72">
                  <span className="w-5 h-5 rounded-full bg-[#0B6B3A]/40 flex items-center justify-center flex-shrink-0" data-id="element-73">
                    <ShieldCheck className="w-3 h-3 text-[#DCF8C6]" data-id="element-74" />
                  </span>
                  {item}
                </li>)}
            </ul>

            {/* CTA Button */}
            <a href="https://www.nachogerberg.com/cart/42518384443463:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="inline-flex items-center justify-center gap-2 bg-[#0B6B3A] hover:bg-[#095c32] text-white text-xl font-bold py-5 px-10 rounded-xl shadow-[0_0_30px_rgba(11,107,58,0.4)] hover:shadow-[0_0_50px_rgba(11,107,58,0.6)] transition-all transform hover:-translate-y-1 w-full" data-id="element-75">
              Quiero el acceso ahora por $6.39
              <ArrowRight className="w-5 h-5" data-id="element-76" />
            </a>

            <p className="text-gray-500 text-sm mt-3" data-id="element-77">
              Precio de lanzamiento. Sube cuando termine la validación.
            </p>
          </motion.div>

          {/* Trust signals */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 max-w-2xl mx-auto" data-id="element-78">
            {[{
            icon: <Lock className="w-4 h-4" data-id="element-79" />,
            text: 'Pago 100% seguro'
          }, {
            icon: <Download className="w-4 h-4" data-id="element-80" />,
            text: 'Acceso inmediato'
          }, {
            icon: <Smartphone className="w-4 h-4" data-id="element-81" />,
            text: 'Instagram, Facebook y WhatsApp'
          }, {
            icon: <MessageCircle className="w-4 h-4" data-id="element-82" />,
            text: 'Para negocios, freelancers y servicios'
          }, {
            icon: <RotateCcw className="w-4 h-4" data-id="element-83" />,
            text: 'Garantía de devolución incluida'
          }, {
            icon: <ShieldCheck className="w-4 h-4" data-id="element-84" />,
            text: 'Sin suscripción'
          }].map((item, i) => <div key={i} className="flex items-center justify-center gap-2 text-gray-500 text-xs" data-id="element-85">
                <span className="text-[#0B6B3A]" data-id="element-86">{item.icon}</span>
                {item.text}
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}